/* eslint-disable */
export default {
  logged: 'ログ記録済み',
  unlogged: '未処理',
  faxNotSupported: 'FAXのログ記録はサポートされていません。',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
